import React, { useCallback, useEffect, useState } from "react";
import apiRequests from "../../Component/axios/config/config";
import { useNavigate } from "react-router-dom";
import Pagination from "../../Component/pagination/Pagination";

const MainTicketPage = () => {
  const [listType, setListType] = useState("all");
  const [loading, setloading] = useState(false);
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

  const changeType = (typeName) => {
    setListType(typeName);
      setPage(1);
  };
  const fetchTickets = () => {
    setloading(true);
    const endpoint =
      listType == "all"
        ? "/api/tickets/v1/get-my-ticket-list-admin"
        : "/api/tickets/v1/get-seller-ticket-list-admin";
    apiRequests.get(endpoint , {
        params: {
            pagination: true,
            page: page,
            limit: 8,
        },
    }).then((response) => {
      console.log(response.data);

      const docs = response?.data.data.docs || [];

      setTickets(docs);
      setloading(false);
      setTotalPages(response.data.data.totalPages)
        console.log("fdsdjhskj",totalPages)
    });
  };
  useEffect(() => {
    fetchTickets();
  }, [listType, page]);

    const goToPage = (newPage) => {
        if (newPage < 1 || newPage > totalPages) return;

        setPage(newPage);
    };

    return (
    <div className="p-6">
      <div className="flex justify-between items-center">
        <div className="flex justify-center items-center">
          <h1 className="text-3xl font-bold text-gray-800">Tickets</h1>
        </div>
        <div className="flex items-center border border-gray-300 rounded-xl px-4 py-2 gap-4">
          <button
            className={`px-4 py-1 rounded-xl ${
              listType === "all"
                ? "bg-baseColor-button text-white"
                : "bg-transparent"
            }`}
            onClick={() => {
              changeType("all");
            }}
          >
            All
          </button>
          <button
            className={`px-4 py-1 rounded-xl ${
              listType === "seller"
                ? "bg-baseColor-button text-white"
                : "bg-transparent"
            }`}
            onClick={() => {
              changeType("seller");
            }}
          >
            seller
          </button>
        </div>
      </div>
        {loading ? (
            <>
            </>
        ):(
             <div className="w-full p-3">
                <div className="grid grid-cols-2 gap-2">
                    {tickets?.map((ticket) => (
                        <div key={ticket._id} className="">
                            <div className="rounded-lg border border-firstColor-shade5 flex flex-col  items-center justify-center">
                                <div className="flex flex-col items-center justify-center w-full px-3 gap-2 pb-4">
                                    <p className="truncate w-full justify-start text-2xl flex flex-col">
                                        <span className="text-sm ">
                                            subject:
                                        </span>
                                        <span>
                                            {ticket.subject}
                                        </span>
                                    </p>
                                    <div className="flex justify-between w-full">
                                        <p className={`${ticket.status === "answered" ? "text-buttonColor-shade2" : "text-red-300"} w-full justify-start`}>
                                            {ticket.status}
                                        </p>
                                        <p className="flex gap-2 items-center">
                                            <span className="text-sm">sender:</span>
                                            {ticket.creator?.user_id?.userName || ticket.creator?.seller_id?.userName}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    className="col-span-1 text-white bg-firstColor-shade4 w-full rounded-b-lg py-1"
                                    onClick={() => {
                                        navigate(`/ticket/${ticket._id}`);
                                    }}
                                >
                                    see chat
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
                 <Pagination
                     page={page}
                     totalPages={totalPages}
                     onPageChange={goToPage}
                 />
            </div>
        )}

      {/*<section className="w-full flex flex-col justify-center mt-6">*/}
      {/*  {loading ? (*/}
      {/*    <p>loading...</p>*/}
      {/*  ) : (*/}
      {/*    tickets?.map((ticket) => (*/}
      {/*      <div*/}
      {/*        key={ticket._id}*/}
      {/*        className="w-full border-t grid grid-cols-3 justify-between py-3 sm:text-sm"*/}
      {/*      >*/}
      {/*        <div className="flex flex-col items-start gap-2">*/}
      {/*          <p className="col-span-1 truncate w-64">subject: {ticket.subject}</p>*/}
      {/*          <p*/}
      {/*            className={*/}
      {/*              ticket.status === "answered"*/}
      {/*                ? `text-buttonColor-shade2`*/}
      {/*                : `text-red-300`*/}
      {/*            }*/}
      {/*          >*/}
      {/*            {ticket.status}*/}
      {/*          </p>*/}
      {/*        </div>*/}

      {/*        <p className="col-span-1 flex items-center justify-center text-center">*/}
      {/*          user:{" "}*/}
      {/*          {ticket.creator?.user_id?.userName ||*/}
      {/*            ticket.creator?.seller_id?.userName}*/}
      {/*        </p>*/}

      {/*        <button*/}
      {/*          className="col-span-1 text-baseColor-button"*/}
      {/*          onClick={() => {*/}
      {/*            navigate(`/ticket/${ticket._id}`);*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          see chat*/}
      {/*        </button>*/}
      {/*      </div>*/}
      {/*    ))*/}
      {/*  )}*/}
      {/*    <Pagination*/}
      {/*        page={page}*/}
      {/*        totalPages={totalPages}*/}
      {/*        onPageChange={goToPage}*/}
      {/*    />*/}
      {/*</section>*/}
    </div>
  );
};

export default MainTicketPage;
